import api from './itemsApiClient';

/** Public listing engagement APIs (flags, favorites, CTR). Safe for the main storefront bundle. */

export const flagAPI = {
  /** Submit a flag on an item. listing_type: 'item' | 'designer_item' */
  flagListing: async (listingId, listingType, reason) => {
    const res = await api.post('/flags/', { listing_id: listingId, listing_type: listingType, reason });
    return res.data;
  },

  /** Get aggregated flag score for a listing */
  getFlagScore: async (listingId, listingType = 'item') => {
    const res = await api.get(`/flags/score/${listingType}/${listingId}/`);
    return res.data;
  },
};

export const scoresAPI = {
  recordFavorite: async (listingId, listingType = 'item') => {
    const res = await api.post('/scores/favorite/', { listing_id: listingId, listing_type: listingType });
    return res.data;
  },

  recordCartAdd: async (listingId, listingType = 'item') => {
    const res = await api.post('/scores/cart-add/', { listing_id: listingId, listing_type: listingType });
    return res.data;
  },
};

let _impressionBuffer = [];
let _flushTimer = null;

function _flushImpressions() {
  if (_impressionBuffer.length === 0) return;
  const batch = _impressionBuffer.splice(0, 200);
  api.post('/analytics/impressions/', { items: batch }).catch(() => {});
}

export const analyticsAPI = {
  /** Queue an impression — auto-flushed every 3 s or when buffer hits 50 */
  recordImpression: (listingId, listingType = 'item') => {
    _impressionBuffer.push({ listing_id: listingId, listing_type: listingType });
    if (_impressionBuffer.length >= 50) {
      _flushImpressions();
    } else if (!_flushTimer) {
      _flushTimer = setTimeout(() => {
        _flushImpressions();
        _flushTimer = null;
      }, 3000);
    }
  },

  flushImpressions: _flushImpressions,

  recordClick: async (listingId, listingType = 'item') => {
    await api.post('/analytics/clicks/', { listing_id: listingId, listing_type: listingType }).catch(() => {});
  },
};
